<div mat-dialog-title [attr.dir]="lang == 'ar' ? 'rtl' : 'ltr'"
  class="modal-header-bg d-flex justify-content-end px-3 pt-1">
  <button mat-icon-button aria-label="close dialog close-icon-border" mat-dialog-close>
    <mat-icon class="text-color-theme">X</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <div [attr.dir]="lang == 'ar' ? 'rtl' : 'ltr'">
    <div class="container modal-container px-3">
      <!-- <div *ngIf="numberOfAccounts==0" class="container modal-container d-flex flex-column justify-content-center align-items-center p-3">
                <div class="row  d-flex flex-column justify-content-center  align-items-center ">
                    <div class="text-color-theme">Open Fund Account Now!</div>
                    <div class="dimmed-Title">You can start your fund trading now by opening an account </div>
                </div>
                <div  class="vector-width " >
                    <img class="mx-auto" src="/assets/img/fund-vector.svg" alt="">
                </div>
               <button class="rounded-theme-btn" (click)="openFundAccount()">Open Account</button> 
                <button class="rounded-theme-btn" (click)="openFundAccount()">Open Account</button>
            </div> -->

      <mat-horizontal-stepper *ngIf="numberOfAccounts > 0" appDisableLabelClick [linear]="true" #stepper>
        <mat-step *ngIf="accList.length > 1" [completed]="accountSelected" [label]="'ChooseAccount' | translate">
          <div class="alert-div alert-div-warning d-flex flex-wrap mt-2">
            <div class="content-w mx-2 d-flex flex-column align-items-start">
              <div class="d-flex">
                <div class="icon-w">
                  <img src="assets/img/warning.svg" alt="" />
                </div>
                <span class="yellow-text mx-1 font-600">
                  {{ "IPOAlertTitle" | translate }}
                </span>
              </div>
              <span class="alert-desc-color font-small mx-4 text-start">
                {{ "IPOAlertText" | translate }}
              </span>
            </div>
          </div>
          <div class="container modal-container d-flex flex-column justify-content-start p-3">
            <ng-container *ngFor="let acc of accList">
              <div class="account-card d-flex justify-content-between align-items-center mx-1 clickable"
                (click)="selectAccount(stepper, acc)">
                <div class="d-flex align-items-center">
                  <div class="IPO-card-logo-container d-flex align-item-center">
                    <img class="avatar" src="assets/img/male-fund-avatar.svg" alt="" />
                  </div>
                  <div class="mx-3 text-start">
                    <h6 class="text-color-theme font-small">
                      {{ lang == "ar" ? acc?.clientNameAr : acc?.clientNameEn }}
                    </h6>
                    <div class="d-flex align-items-center">
                      <h6 class="text-highlight-company-color font-small font-600 mx-2">
                        {{ acc?.relationCode }}
                      </h6>
                    </div>
                  </div>
                </div>
                <div>
                  <span [ngClass]="{
                    'Basic':acc.accountType==BASIC,
                    'Minor':acc.accountType==MINOR
                  }" class=" rounded-div px-3 py-1">{{
                    lang == "ar" ? acc?.accountTypeAr : acc?.accountTypeEn
                    }}</span>
                </div>
              </div>
              <div *ngIf="acc != accList.length" class="horizonatl-line my-3"></div>
            </ng-container>
          </div>
        </mat-step>

        <mat-step [label]="isBuy ? ('buy' | translate) : ('sell' | translate)"
          [ngClass]="{ 'overlay-loading': isLoading }" [completed]="isStep1Completed">
          <div class="step-content-width mx-auto">
            <div
              class="symbol-header my-3 d-flex flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-xs-column flex-column justify-content-between align-items-center mx-1">
              <div class="d-flex">
                <div class="IPO-card-logo-container d-flex align-item-center">
                  <img class="avatar" src="{{ IPOdetails.Logo }}" alt="" />
                </div>
                <div class="mx-3 d-flex flex-column align-items-start">
                  <h6 class="text-color-theme font-small">
                    {{ lang == "ar" ? IPOdetails.NameAr : IPOdetails.NameEn }}
                  </h6>
                  <h6 class="text-color-theme font-small">
                    <span class="font-700" [ngClass]="{ 'green-text': isBuy, 'red-text': !isBuy }">{{ "buy" | translate
                      }}
                    </span>
                    {{
                    translate.currentLang == "en"
                    ? IPOdetails.NameEn
                    : IPOdetails.NameAr
                    }}
                    @
                    {{
                    IPOdetails.StockPrice | number : "1.2-2" | numberFormat
                    }}
                    {{
                    IPOdetails.CurrencyId == 1
                    ? translate.currentLang == "en"
                    ? IPOdetails.AbbreviationEn
                    : IPOdetails.AbbreviationAr
                    : translate.currentLang == "en"
                    ? IPOdetails.AbbreviationEn
                    : IPOdetails.AbbreviationAr
                    }}
                  </h6>
                  <h6 class="text-color-theme font-small">
                    {{
                    translate.currentLang == "en"
                    ? selectedAccount?.clientNameEn
                    : selectedAccount?.clientNameAr
                    }}
                  </h6>
                </div>
              </div>
              <div class="d-flex flex-column">
                <span [ngClass]="{
                  'Basic':selectedAccount.accountType==BASIC,
                  'Minor':selectedAccount.accountType==MINOR
                }" class="rounded-div px-3 py-1 font-600 text-center">
                  {{
                  translate.currentLang == "en"
                  ? selectedAccount?.accountTypeEn
                  : selectedAccount?.accountTypeAr
                  }}</span>
                <h6 class="text-highlight-company-color font-small font-600 mx-2 mt-2">
                  {{ selectedAccount?.relationCode }}
                </h6>
              </div>
            </div>
            <div class="mt-2" *ngIf="!isLoading">
              <div [ngClass]="{
                  'buy-linear-card buy-linear-card-text': isBuy,
                  'sell-linear-card sell-linear-card-text': !isBuy
                }" class="mx-auto my-3 d-flex flex-column justify-content-center align-items-center py-4 px-5">
                <span [ngClass]="{
                    'text-red-bold':
                      (IPOdetails.CurrencyId == 1
                        ? EgpPurchasePower
                        : UsdPurchasePower) < 0,
                    'text-muted font-600':
                      (IPOdetails.CurrencyId == 1
                        ? EgpPurchasePower
                        : UsdPurchasePower) >= 0
                  }">
                  {{ "balance" | translate }}
                  {{
                  IPOdetails.CurrencyId == 1
                  ? (EgpPurchasePower | number : "1.2-2" | numberFormat)
                  : (UsdPurchasePower | number : "1.2-2" | numberFormat)
                  }}
                  {{
                  IPOdetails.CurrencyId == 1
                  ? translate.currentLang == "en"
                  ? IPOdetails.AbbreviationEn
                  : IPOdetails.AbbreviationAr
                  : translate.currentLang == "en"
                  ? IPOdetails.AbbreviationEn
                  : IPOdetails.AbbreviationAr
                  }}
                </span>
                <span class="mb-2">{{ "IPOBalance" | translate }}</span>
                <span class="tx-20 font-600">{{
                  IPOdetails.CurrencyId == 1
                  ? (IPOBalanceEGP | number : "1.2-2" | numberFormat)
                  : (IPOBalanceUSD | number : "1.2-2" | numberFormat)
                  }}
                  {{
                  IPOdetails.CurrencyId == 1
                  ? translate.currentLang == "en"
                  ? IPOdetails.AbbreviationEn
                  : IPOdetails.AbbreviationAr
                  : translate.currentLang == "en"
                  ? IPOdetails.AbbreviationEn
                  : IPOdetails.AbbreviationAr
                  }}
                </span>
                <ng-container *ngIf="typeSelected == 'CERTIFICATE'">
                  <span class="mb-2">Your Certificates</span>
                  <span class="tx-20 font-600">100</span>
                </ng-container>
              </div>

              <div class="d-flex align-items-center justify-content-between">
                <span class="text-color-theme">{{
                  "enterQuantity" | translate
                  }}</span>
                <span *ngIf="typeSelected == 'CERTIFICATE'" class="text-color-theme">Enter Certificate Number</span>
                <button [ngClass]="{
                    'green-rounded-highlight': isBuy,
                    'red-rounded-highlight': !isBuy
                  }" (click)="calculateMaxQuantity(true)" class="no-border clickable text-center width-fit">
                  {{ "max" | translate }}
                </button>
              </div>
              <div class="w-100 input-wrapper mx-auto my-2">
                <span [ngClass]="{ right: lang == 'ar', left: !(lang == 'ar') }" class="text-color-theme input-span">
                  {{ quantityControl.value || "" }}
                </span>
                <input [formControl]="quantityControl" type="text" class="buy-sell-input w-100 text-color-theme" />
                <!-- <span [ngClass]="{'left': (lang=='ar'), 'right': !(lang=='ar')}" class="text-color-theme input-span">
                                    {{ IPOdetails.CurrencyId == 1 
                                        ? (translate.currentLang == 'en' ? IPOdetails.AbbreviationEn : IPOdetails.AbbreviationAr) 
                                        : (translate.currentLang == 'en' ? IPOdetails.AbbreviationEn : IPOdetails.AbbreviationAr) 
                                    }}
                                </span> -->
              </div>

              <div class="row mb-3">
                <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12 col-12">
                  <div class="d-flex" *ngIf="
                      minQtyIndividual > 0 &&
                      quantityControl.value > 0 &&
                      quantityControl.value < minQtyIndividual
                    ">
                    <span class="text-red-bold">{{ "MinQauntity" | translate }}:
                    </span>
                    <span class="text-red-bold">
                      {{ minQtyIndividual | numberFormat }}</span>
                  </div>
                  <div class="d-flex">
                    <span class="dimmed-Title">{{ "order-value" | translate }}
                    </span>
                    <span class="text-highlight-company-color font-600">
                      {{ orderValue | number : "1.2-2" | numberFormat }}
                      {{
                      IPOdetails.CurrencyId == 1
                      ? translate.currentLang == "en"
                      ? IPOdetails.AbbreviationEn
                      : IPOdetails.AbbreviationAr
                      : translate.currentLang == "en"
                      ? IPOdetails.AbbreviationEn
                      : IPOdetails.AbbreviationAr
                      }}</span>
                  </div>

                  <div class="d-flex">
                    <span class="dimmed-Title">{{ "order-fees" | translate }}:
                    </span>
                    <span class="text-highlight-company-color font-600">
                      {{ orderFees | number : "1.2-2" | numberFormat }}
                      {{
                      IPOdetails.CurrencyId == 1
                      ? translate.currentLang == "en"
                      ? IPOdetails.AbbreviationEn
                      : IPOdetails.AbbreviationAr
                      : translate.currentLang == "en"
                      ? IPOdetails.AbbreviationEn
                      : IPOdetails.AbbreviationAr
                      }}</span>
                  </div>
                </div>
                <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 col-12">
                  <div class="d-flex" *ngIf="
                      maxQtyIndividual > 0 &&
                      quantityControl.value > 0 &&
                      quantityControl.value > maxQtyIndividual
                    ">
                    <span class="text-red-bold">{{ "MaxQauntity" | translate }}:
                    </span>
                    <span class="text-red-bold">
                      {{ maxQtyIndividual | numberFormat }}</span>
                  </div>
                  <div class="d-flex">
                    <span class="dimmed-Title">{{ "MaxQauntity" | translate }}:
                    </span>
                    <span class="text-highlight-company-color font-600">
                      {{
                      IPOdetails.CurrencyId == 1
                      ? (maxQuantiyEGP | numberFormat)
                      : (maxQuantiyUSD | numberFormat)
                      }}</span>
                  </div>

                  <div class="d-flex">
                    <span class="dimmed-Title">{{ "total-cost" | translate }}:
                    </span>
                    <span class="text-highlight-company-color font-600">
                      {{ orderTotal | number : "1.2-2" | numberFormat }}
                      {{
                      IPOdetails.CurrencyId == 1
                      ? translate.currentLang == "en"
                      ? IPOdetails.AbbreviationEn
                      : IPOdetails.AbbreviationAr
                      : translate.currentLang == "en"
                      ? IPOdetails.AbbreviationEn
                      : IPOdetails.AbbreviationAr
                      }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="alert-div alert-div-error d-flex flex-wrap" *ngIf="
                (!isValidOrder && orderValue > 0) ||
                ((IPOdetails.CurrencyId == 1
                  ? EgpPurchasePower
                  : UsdPurchasePower) < 0 &&
                  !isLoading)
              ">
              <div class="content-w mx-2 d-flex flex-column align-items-start">
                <div class="d-flex">
                  <div class="icon-w">
                    <img src="assets/img/error-icon.svg" alt="" />
                  </div>
                  <span class="red-text mx-1 font-600">
                    {{ "IPOExceedTitle" | translate }}
                  </span>
                </div>
                <span class="alert-desc-color font-small mx-4 text-start">
                  {{ "IPOExceedText" | translate }}
                </span>
              </div>
            </div>

            <div class="d-flex align-items-center justify-content-center" *ngIf="!isLoading">
              <button [ngClass]="{
                  'green-btn': isBuy,
                  'red-btn': !isBuy,
                  disabled:
                    !isValidOrder ||
                    orderValue <= 0 ||
                    isLessThanMin ||
                    isMoreThanMax
                }" class="my-3 rounded-btn" (click)="createOrder(stepper)">
                {{ "Next" | translate }}
              </button>
            </div>
          </div>
        </mat-step>
        <!-- TODO: Complete validation on step when adding component's business -->
        <mat-step [label]="'SubmitOrder' | translate" [completed]="isStep2Completed">
          <div
            class="symbol-header d-flex flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-xs-column flex-column justify-content-between align-items-center mx-1">
            <div class="d-flex">
              <div class="IPO-card-logo-container d-flex align-item-center">
                <img class="avatar" src="{{ IPOdetails.Logo }}" alt="" />
              </div>
              <div class="mx-3 d-flex flex-column align-items-start">
                <h6 class="text-color-theme font-small">
                  <span class="font-700" [ngClass]="{ 'green-text': isBuy, 'red-text': !isBuy }">{{ "buy" | translate }}
                  </span>
                  {{
                  translate.currentLang == "en"
                  ? IPOdetails.NameEn
                  : IPOdetails.NameAr
                  }}
                  @
                  {{ IPOdetails.StockPrice | number : "1.2-2" | numberFormat }}
                  {{
                  IPOdetails.CurrencyId == 1
                  ? translate.currentLang == "en"
                  ? IPOdetails.AbbreviationEn
                  : IPOdetails.AbbreviationAr
                  : translate.currentLang == "en"
                  ? IPOdetails.AbbreviationEn
                  : IPOdetails.AbbreviationAr
                  }}
                </h6>
                <h6 class="text-color-theme font-small">
                  {{
                  translate.currentLang == "en"
                  ? selectedAccount?.clientNameEn
                  : selectedAccount?.clientNameAr
                  }}
                </h6>
              </div>
            </div>

            <div class="d-flex flex-column">
              <span [ngClass]="{
                'Basic':selectedAccount.accountType==BASIC,
                'Minor':selectedAccount.accountType==MINOR
              }" class="rounded-div px-3 py-1 font-600 text-center">{{
                translate.currentLang == "en"
                ? selectedAccount?.accountTypeEn
                : selectedAccount?.accountTypeAr
                }}</span>
              <h6 class="text-highlight-company-color font-small font-600 mx-2 mt-2">
                ({{ selectedAccount?.relationCode }})
              </h6>
            </div>
          </div>

          <div class="w-100 IPO-card IPO-unselected-card d-flex flex-column mt-3 mb-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-color-theme">{{ "market" | translate }}</span>
              <span class="text-color-theme"> {{ "mutual-fund" | translate }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-color-theme">{{ "Quantity" | translate }}</span>
              <span class="text-color-theme">
                {{ quantityControl.value | numberFormat }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-color-theme">{{
                "order-value" | translate
                }}</span>
              <span class="text-color-theme">
                {{ orderValue | number : "1.2-2" | numberFormat }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-color-theme">{{ "Block" | translate }}
                {{
                IPOdetails.PaidPer | number : "1.2-2" | numberFormat
                }}%</span>
              <span class="text-color-theme">
                {{
                orderValue * (IPOdetails.PaidPer / 100)
                | number : "1.2-2"
                | numberFormat
                }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-color-theme">{{ "DateTime" | translate }}</span>
              <span class="text-color-theme"> {{ currentDate }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-color-theme">{{ "Expiry" | translate }}</span>
              <span class="text-color-theme">{{
                "GoodTillCancel" | translate
                }}</span>
            </div>
          </div>

          <div class="d-flex flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-xs-column flex-column">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 col-12 mb-1">
              <div class="IPO-card IPO-unselected-card padding-10 d-flex flex-column">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="text-color-theme">{{
                    "order-fees" | translate
                    }}</span>
                  <span class="text-color-theme">
                    {{ orderFees | number : "1.2-2" | numberFormat }}
                    {{
                    IPOdetails.CurrencyId == 1
                    ? translate.currentLang == "en"
                    ? IPOdetails.AbbreviationEn
                    : IPOdetails.AbbreviationAr
                    : translate.currentLang == "en"
                    ? IPOdetails.AbbreviationEn
                    : IPOdetails.AbbreviationAr
                    }}</span>
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 col-12 mb-1">
              <div class="padding-10 IPO-card IPO-unselected-card d-flex flex-column">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="text-color-theme">{{
                    "EstimatedTotal" | translate
                    }}</span>
                  <span class="text-highlight-company-color font-600">
                    {{ orderTotal | number : "1.2-2" | numberFormat }}
                    {{
                    IPOdetails.CurrencyId == 1
                    ? translate.currentLang == "en"
                    ? IPOdetails.AbbreviationEn
                    : IPOdetails.AbbreviationAr
                    : translate.currentLang == "en"
                    ? IPOdetails.AbbreviationEn
                    : IPOdetails.AbbreviationAr
                    }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="alert-div alert-div-warning d-flex flex-wrap mt-2">
            <div class="content-w mx-2 d-flex flex-column align-items-start">
              <div class="d-flex">
                <div class="icon-w">
                  <img src="assets/img/ring.svg" alt="" />
                </div>
                <span class="yellow-text mx-1 font-600">
                  {{ "IPOsubmitOrderAlertTitle" | translate }}
                </span>
              </div>
              <span class="alert-desc-color font-small mx-4 text-start">
                {{ "IPOsubmitOrderAlertText" | translate }}
              </span>
            </div>
          </div>
          <div class="spinner-alignments" *ngIf="isSendingOrder">
            <div class="spinner-container">
                <div class="spinner"></div>
            </div>
        </div>
          <div *ngIf="!isSendingOrder" class="d-flex align-items-center justify-content-center">
            <button 
              class="my-3 theme-btn rounded-btn"
              (click)="submitOrder(stepper)"
            >
              {{ "SubmitOrder" | translate }}
            </button>
          </div>
        </mat-step>
        <mat-step [label]="'Done' | translate">
          <div class="step-content-width mx-auto">
            <ng-container *ngIf="sendingOrder">
              <div class="vector-width d-flex flex-column justify-content-center align-items-center mb-2 mx-auto">
                <img class="mx-auto" src="assets/img/Done.svg" alt="" />
              </div>
              <div class="row d-flex flex-column justify-content-center align-items-center">
                <div class="text-color-theme">
                  {{ "IPOSuccessAlertTitle" | translate }}
                </div>
                <div class="dimmed-Title">
                  {{ "IPOSuccessAlertText" | translate }}
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!sendingOrder">
              <div class="vector-width d-flex flex-column justify-content-center align-items-center mb-2 mx-auto">
                <img class="mx-auto" src="assets/img/error.svg" alt="" />
              </div>
              <div class="row d-flex flex-column justify-content-center align-items-center">
                <div class="text-color-theme">{{ "Sorry" | translate }}</div>
                <div class="dimmed-Title">
                  {{ "IPOFailedSendOrder" | translate }}
                </div>
              </div>
            </ng-container>
            <div class="d-flex align-items-center justify-content-center">
              <button class="my-3 theme-btn rounded-btn" (click)="closeModal()">
                {{ "Done" | translate }}
              </button>
            </div>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </div>
</div>